module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Slot/images/slot-icon-100.5a73364f.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Slot/images/slot-icon-100.png
// module id = 3366
// module chunks = 11